<template>
<svg width="40" height="40" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="25" cy="25" r="25" fill="#F0F5FA"/>
<path d="M33.1667 15.6665H16.8333C15.5447 15.6665 14.5 16.7112 14.5 17.9998V34.3332C14.5 35.6218 15.5447 36.6665 16.8333 36.6665H33.1667C34.4553 36.6665 35.5 35.6218 35.5 34.3332V17.9998C35.5 16.7112 34.4553 15.6665 33.1667 15.6665Z" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M29.6665 13.3335V18.0002" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.3335 13.3335V18.0002" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.5 22.6665H35.5" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
<script>
export default({
    props: {
        color:{
            default:'#727D94'
        }
    },
})
</script>
